// lib/data/index.ts
// Barrel export for all data modules

// Lodges
export {
  lodges,
  getLodgeBySlug,
  getLodgeById
} from './lodges';
export type { Lodge } from './lodges';

// Adventures
export {
  adventures,
  getAdventureById,
  getAdventureHeroImages
} from './adventures';
export type { Adventure } from './adventures';

// Packages
export {
  packages,
  getPackageBySlug,
  getPackageById,
  getFeaturedPackages,
  getActivePackages,
  getPackageLodge,
  formatPackagePrice
} from './packages';
export type { PackageData, PackageActivity } from './packages';

// Testimonials
export {
  testimonials,
  getTestimonialById,
  getFeaturedTestimonials
} from './testimonials';
export type { Testimonial } from './testimonials';

// Destinations
export {
  destinations,
  getDestinationById,
  getDestinationHeroImages,
  getDestinationsByRegion,
  getDestinationsBySeason
} from './destinations';
export type { Destination } from './destinations';

// Events
export { upcomingEvents } from './events';
export type { Event } from './events';

// Why Apex
export {
  differentiators,
  stats,
  guarantee
} from './why-apex';
export type { Differentiator, Stat } from './why-apex';

// Experiences
export {
  experiences,
  getExperienceById,
  getExperienceHeroImages
} from './experiences';
export type { Experience } from './experiences';
